import { isNull } from "lodash";

/**
 * Formats a numeric value using US locale separators and fixed decimal precision.
 *
 * Behavior:
 * - Rounds the value to `precision` decimal places.
 * - Pads trailing zeros to match `precision`.
 * - Adds thousands separators (`,`).
 * - Returns the string `"NaN"` when `value` is `null` or `NaN`.
 *
 * @param value Numeric value to format.
 * @param precision Number of decimal places to render. Defaults to `0`.
 * @returns A formatted numeric string or `"NaN"` for invalid/null input.
 */
export const displayNumber = (value: number | null, precision = 0) => {
  if (isNull(value) || isNaN(value)) {
    return "NaN";
  }

  return Intl.NumberFormat("en-us", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(value);
};
